module.exports = __webpack_public_path__ + "media/images/page/ico_medal3-94b8f11432551a30203a0516e5f742d5.svg";